import Vue from 'vue'
import lib from '@/library'

const actions = {
  getAvailableVouchers (context) {
    // console.log('getAvailableVouchers')
    let optionsNoFilter = {
      IDMMAccount: null,
      OrderBy: 'TSCREATED',
      OrderType: 'ASC'
    }
    let isLoggedIn = context.getters['isLoggedIn']

    return isLoggedIn && context.getters.getApplicableVouchers &&
      lib.rpcService.callBroker('AccountService', 'GetAccountPromotionalVouchers', optionsNoFilter)
      .then(response => {
        // console.log('getAvailableVouchers:', response.result)
        let currentBetSlipState = context.getters.currentBetSlipState
        if (!currentBetSlipState) {
          let availableVouchers = context.getters.getAvailableVouchers || []
          let availableVouchersIds = availableVouchers.map(v => v.IDMMPRVoucher + '')
          let availableVouchersIdsNew = (response.result || []).map(v => v.IDMMPRVoucher + '')
          let missingVouchers = availableVouchersIds.filter(id => !availableVouchersIdsNew.includes(id))
          if (missingVouchers && missingVouchers.length) {
            context.commit('clearAppliedVouchersById', missingVouchers)
          }
        }
        context.commit('setAvailableVouchers', response.result)
      })
      .catch(() => {
        context.commit('resetAvailableVouchers')
      })
      .finally(() => {
        let availableVouchersCheckInterval = context.getters['availableVouchersCheckInterval']
        if (availableVouchersCheckInterval) {
          clearTimeout(context.state.timeouts.availableVouchersCheck)
          context.state.timeouts.availableVouchersCheck = setTimeout(() => {
            context.dispatch('getAvailableVouchers')
          }, availableVouchersCheckInterval * 1000)
        }
      })
  },
  applicableVouchersOnLogIn (context) {
    // console.log('applicableVouchersOnLogIn')
    setTimeout(() => {
      context.dispatch('getAvailableVouchers')
    }, 300)
  },
  applicableVouchersOnLogOut (context) {
    context.dispatch('clearApplicableVouchersData', 'onLogOut')
    context.commit('setAvailableVouchers', [])
  },
  clearApplicableVouchersData (context, reason) {
    // console.log('clearApplicableVouchersData')
    context.commit('setPromotionVouchers', [[], null, reason])
    context.commit('resetVoucherRrequestData')
    context.commit('clearAppliedVouchers')
  },

  processVouchers (context, abtnr) {
    // console.log('processVouchers:', abtnr)

    const processBetType = (bt) => {
      let applicableVouchers = []
      let promotionVouchers = bt.Vouchers || []
      if (promotionVouchers && promotionVouchers.length) {
        let availableVouchers = context.getters.getAvailableVouchers || []
        // console.log('applicableVouchers for', bt.betId, 'of vouchers:', promotionVouchers.length)
        for (let voucher of promotionVouchers) {
          let avouchers = availableVouchers.filter(av => {
            // console.log('av:', av)
            return av && av.IDMMPRVoucherType === voucher.VoucherTypeId
          })
          avouchers = avouchers.map(v => {
            let cv = JSON.parse(JSON.stringify(v))
            for (let p in voucher) {
              Vue.set(cv, p, voucher[p])
            }
            return cv
          })
          applicableVouchers = applicableVouchers.concat(avouchers)
        }
        // console.log('applicableVouchers:', bt.betId, ':', applicableVouchers, applicableVouchers.length)
        // console.log('availableVouchers:', this.availableVouchers)
      }
      if (applicableVouchers.length) {
        Vue.set(bt, 'applicableVouchers', applicableVouchers)
      }
    }

    if (abtnr.Vouchers) {
      processBetType(abtnr)
    } else {
      for (let perType in abtnr.PotentialReturns) {
        for (let bt in abtnr.PotentialReturns[perType]) {
          let betType = abtnr.PotentialReturns[perType][bt]
          if (betType) {
            processBetType(betType)
          }
        }
      }
    }
    //
    return abtnr
  },

  attachVoucherToBetSlip (context, betSlip) {
    // console.log('attachVoucherToBetSlip')
    let promotionsEnabled = context.rootGetters['isLoggedIn'] && context.getters.promotionsEnabled && context.getters.getApplicableVouchers
    if (promotionsEnabled && betSlip.betSlip && betSlip.betSlip.Bets && betSlip.betSlip.Bets.length) {
      let promotionVoucherPerTab = (promotionsEnabled && context.getters.appliedVoucher(betSlip.tab)) || false
      if (promotionVoucherPerTab && promotionVoucherPerTab.isActive && promotionVoucherPerTab.voucherId) {
        betSlip.betSlip.IDMMPRVoucher = promotionVoucherPerTab.voucherId
      }
    }
    return betSlip
  },
  applyPromotionVoucher (context, data) {
    // console.log('applyPromotionVoucher:', data)
    let voucher = data.voucher
    let betId = data.betId
    let tab = data.tab
    let caller = data.caller
    context.commit('applyVoucher', {tab, betId, voucher, caller})
  },
  voucherCount (context, data) {
    let currentBetSlipState = context.getters.currentBetSlipState
    // console.log('voucherCount:', data, 'currentBetSlipState:', currentBetSlipState)
    //
    let isLoggedIn = context.getters['isLoggedIn']
    if (!isLoggedIn) {
      return
    }
    if (currentBetSlipState) {
      return
    }
    let applicableVouchersCountInProgress = context.getters.applicableVouchersCountInProgress
    if (!applicableVouchersCountInProgress) {
      Vue.set(context.state.promotions, 'applicableVouchersCountInProgress', true)
      Vue.set(context.state.promotions, 'applicableVouchersCount', {})
    }
    //
    Vue.set(context.state.promotions.applicableVouchersCount, data.betId, data.applicableVouchersLength)
    //
    clearTimeout(context.state.promotions.applicableVouchersCountProgressTO)
    context.state.promotions.applicableVouchersCountProgressTO = setTimeout(() => {
      // console.log('voucherCount-TO', data.betId, 'currentBetSlipState:', context.getters.currentBetSlipState)
      if (context.getters.currentBetSlipState) {
        return
      }
      clearTimeout(context.state.promotions.applicableVouchersCountProgressTO)
      Vue.set(context.state.promotions, 'applicableVouchersCountInProgress', false)
      // let applicableVouchersCountInProgress = context.getters.applicableVouchersCountInProgress
      let tab = context.getters.tab
      let appliedVoucher = context.getters.appliedVoucher(tab) || null
      if (appliedVoucher && appliedVoucher.id && appliedVoucher.isBetAvailable && appliedVoucher.isActive === true) {
        return
      }
      let autoApplySingleVoucher = context.getters.autoApplySingleVoucher
      let autoApply1stVoucher = context.getters.autoApply1stVoucher
      if (!autoApplySingleVoucher && !autoApply1stVoucher) {
        return
      }
      let applicableVouchersCount = context.getters.applicableVouchersCount
      let betsWithVouchers = []
      for (let i in applicableVouchersCount) {
        if (applicableVouchersCount[i]) {
          betsWithVouchers.push([i, applicableVouchersCount[i]])
        }
      }
      // context.commit('clearAutoAppliedVoucher', tab)
      if (betsWithVouchers.length === 1) {
        let [betId, vouchersNo] = betsWithVouchers[0]
        // console.log('Only ONE bet type with voucher(s):', betId, 'with vouchers no:', vouchersNo)
        if ((autoApplySingleVoucher && vouchersNo === 1) || autoApply1stVoucher) {
          context.commit('setAutoApply1stVoucherToBet', betId)
        } else {
          context.commit('clearAutoAppliedVoucher', tab)
        }
      } else {
        context.commit('clearAutoAppliedVoucher', tab)
      }
    }, 50)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslipV2/actions/applicableVouchers.js